import React, { useEffect, useState, useMemo } from "react";

import SearchButton from "../../../components/buttons/search/search-btn";
import { newCompanyStatus } from "../companyRequest/userStatus";
import {
  get_manPowerList_list,
  send_bulk_emails,
} from "../admin.api";
import Notification from "../companyRequest/notification/notification";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import Pagination from "../../../components/table/Pagination";
import TextEditer from "../../../components/inputs/texteditor";
import "./view.css";
import jwtDecode from "jwt-decode";
import moment from "moment";

export default function BulkEmail(props) {
  const [data, setData] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [emailFormData, setEmailFormData] = useState({
    subject: "",
    body_html: "",
    metadata: {
      campaign: "",
      priority: "normal",
    },
  });

  // Pagination settings (same as CustomTable)
  const PageSize = 10;

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
      setSelectAll(false);
    } else {
      const allIds = data.map((item) => item.id);
      setSelectedRows(allIds);
      setSelectAll(true);
    }
  };

  const getStatusClass = (status) => {
    const statusClasses = {
      0: "pending",             // Pending
      1: "inprogress",          // Submitted
      2: "Accepted",            // Accepted / Approved
      3: "inprogress",          // SA Reverted
      4: "rejected",            // Rejected
      5: "inprogress",          // Reverted
      6: "agrementexecution",   // Agreement Execution (kept for consistency)
      7: "Accepted",            // Ongoing Project
    };
    return statusClasses[status] || "";
  };

  const getStatusTitle = (status) => {
    const statusTitles = {
      0: "Pending",
      1: "Submitted",
      2: "Approved",
      3: "SA Reverted",
      4: "Rejected",
      5: "Reverted",
      6: "Agreement Execution",
      7: "Ongoing Project",
    };
    return statusTitles[status] || "";
  };

  const handleUnselectAll = () => {
    setSelectedRows([]);
    setSelectAll(false);
  };

  const handleRowSelect = (id) => {
    if (selectedRows.includes(id)) {
      const newSelectedRows = selectedRows.filter((itemId) => itemId !== id);
      setSelectedRows(newSelectedRows);
      setSelectAll(false);
    } else {
      const newSelectedRows = [...selectedRows, id];
      setSelectedRows(newSelectedRows);
      if (newSelectedRows.length === data.length) {
        setSelectAll(true);
      }
    }
  };

  const handleAdviserList = () => {
    setIsActive(true);
    get_manPowerList_list(adminType)
      .then((res) => {
        let tdata = res.data || [];
        tdata.forEach((item, index) => {
          item["slno"] = index + 1;
        });
        setData(tdata);
        setIsActive(false);
      })
      .catch(() => {
        setIsActive(false);
      });
  };

  const getStatusList = () => {
    setStatuses(newCompanyStatus);
  };

  const handleSearch = () => {
    handleAdviserList();
  };

  const manageStatus = (e) => {
    setActiveStatus(e.target.value);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleAdviserList();
    }
  };

  const handleSendEmail = () => {
    const selectedManpower = data.filter((item) => selectedRows.includes(item.id));
    const emails = selectedManpower.map((item) => item.email).filter((email) => email);

    if (emails.length === 0) {
      setSnackMessage("No valid email addresses found for selected expert manpower");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    // Open email compose popup
    setShowEmailPopup(true);
  };

  const handleEmailSubmit = async () => {
    const selectedManpower = data.filter((item) => selectedRows.includes(item.id));
    const userIds = selectedManpower
      .map((item) => item.user_id)
      .filter((user_id) => user_id);

    const formData = new FormData();

    formData.append("user_category", "expert_manpower");

    userIds.forEach((id) => {
      formData.append("user_ids[]", id);
    });

    formData.append("subject", emailFormData.subject);
    formData.append("body_html", emailFormData.body_html);

    formData.append("metadata[campaign]", emailFormData.metadata.campaign);
    formData.append("metadata[priority]", emailFormData.metadata.priority);

    selectedFiles.forEach((file) => {
      formData.append("documents[]", file);
    });

    try {
      setIsActive(true);
      await send_bulk_emails(formData);

      setSnackMessage(
        `Email sent to ${selectedManpower.length} expert manpower successfully!`,
      );
      setIsSnackError(false);
      setSnackOpen(true);
      setShowEmailPopup(false);

      setSelectedRows([]);
      setSelectAll(false);

      setEmailFormData({
        subject: "",
        body_html: "",
        metadata: {
          campaign: "",
          priority: "normal",
        },
      });
      setSelectedFiles([]);
    } catch (error) {
      console.error("Error sending bulk email:", error);
      setSnackMessage(
        error.message || "Failed to send emails. Please try again.",
      );
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  const handleEmailCancel = () => {
    setShowEmailPopup(false);
    setEmailFormData({
      subject: "",
      body_html: "",
      metadata: {
        campaign: "",
        priority: "normal",
      },
    });
    setSelectedFiles([]);
  };

  const handleEmailFormChange = (field, value) => {
    if (field.includes(".")) {
      const [parent, child] = field.split(".");
      setEmailFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }));
    } else {
      setEmailFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
  };

  const removeFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    handleAdviserList();
  }, []);

  useEffect(() => {
    getStatusList();
  }, []);

  const CustomTableWithCheckbox = ({ data, columns }) => {
    const currentTableData = useMemo(() => {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      return data?.slice(firstPageIndex, lastPageIndex);
    }, [data, currentPage]);

    return (
      <>
        <div className="table-responsive">
          <table className="table-bordered" style={{ width: "100%" }}>
            <thead className="thead-white thed">
              <tr>
                {columns.map((item, index) => (
                  <td
                    key={index}
                    style={{ color: "white", backgroundColor: "#666" }}
                  >
                    {item.title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody style={{ borderRight: "1px solid black" }}>
              {currentTableData && currentTableData.length > 0 ? (
                currentTableData
                  // Show only rows with a valid id, name, and email; this removes any visually blank rows
                  .filter((row) =>
                    row &&
                    row.id &&
                    row.first_name && row.first_name.trim() !== "" &&
                    row.email && row.email.trim() !== ""
                  )
                  .map((row, index) => (
                    <tr key={row.id}>
                      {columns.map((column, colIndex) => (
                        <td key={colIndex}>
                          {column.field === "select" ? (
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(row.id)}
                              onChange={() => handleRowSelect(row.id)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : column.render ? (
                            column.render(row)
                          ) : column.type === "regstatusType" ? (
                            <div className={getStatusClass(parseInt(row[column.field]))}>
                              {getStatusTitle(parseInt(row[column.field]))}
                            </div>
                          ) : (
                            row[column.field]
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan={columns.length} style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {data?.length > PageSize && (
          <div className="mt-3 d-flex justify-content-end">
            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={data.length}
              pageSize={PageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>Expert Manpower - Bulk Email</b>
          </h6>
          <div className="d-flex gap-2">
            {data?.length !== 0 && (
              <>
                <button
                  className="px-2 py-2 btn btn-primary rounded"
                  onClick={handleSelectAll}
                >
                  Select All
                </button>
                {selectedRows.length > 0 && (
                  <button
                    className="px-2 py-2 btn btn-secondary rounded"
                    onClick={handleUnselectAll}
                  >
                    Unselect All
                  </button>
                )}
                {selectedRows.length > 0 && (
                  <button
                    className="px-2 py-2 search-style border-0 text-white rounded"
                    onClick={handleSendEmail}
                  >
                    Send Email ({selectedRows.length})
                  </button>
                )}
              </>
            )}
          </div>
        </div>
        <hr />
        <div className="row font-z">
          <div className="col-3">
            <select
              className="form-select"
              aria-label="Default select example"
              onChange={(e) => manageStatus(e)}
            >
              <option value={""}>Select Status</option>
              {statuses.map((item) => (
                <option
                  key={item.user_status_code}
                  value={item.user_status_code}
                >
                  {item.user_status_title}
                </option>
              ))}
            </select>
          </div>
          <div className="col-1 d-flex">
            <SearchButton {...props} onClick={handleSearch} />
          </div>
        </div>

        <div className="mb-3">
          <small className="text-muted">
            {selectedRows.length} of {data.length} expert manpower selected
          </small>
        </div>

        <CustomTableWithCheckbox
          data={data}
          columns={[
            { title: "Select", field: "select" },
            {
              title: "Name",
              field: "first_name",
              render: (row) => (
                <>
                  {row.first_name && row.first_name} {" "}
                  {row.middle_name && row.middle_name} {" "}
                  {row.last_name && row.last_name}
                </>
              ),
            },
            { title: "Email", field: "email" },
            { title: "Phone Number", field: "phone_no" },
            {
              title: "Status",
              field: "approval_status",
              type: "regstatusType",
            },
          ]}
        />
      </div>

      {/* Email Compose Popup - same style as Resource Person */}
      {showEmailPopup && (
        <div
          className="modal-backdrop"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              paddingLeft: "20px",
              borderRadius: "8px",
              width: "100%",
              maxWidth: "900px",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h5 className="modal-title">Compose Email</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleEmailCancel}
                style={{
                  background: "none",
                  border: "none",
                  color: "white",
                  fontSize: "24px",
                  cursor: "pointer",
                  marginBottom: "10px",
                  fontWeight: "semibold",
                  opacity: 1,
                  filter: "none",
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">
                  To: {selectedRows.length} expert manpower selected
                </label>
              </div>

              <div className="mb-3">
                <label className="form-label">Subject *</label>
                <input
                  type="text"
                  className="form-control"
                  value={emailFormData.subject}
                  onChange={(e) =>
                    handleEmailFormChange("subject", e.target.value)
                  }
                  placeholder="Enter email subject"
                />
              </div>

              <div className="mb-3">
                <TextEditer
                  label="Message (HTML) *"
                  value={emailFormData.body_html}
                  onChange={(value) =>
                    handleEmailFormChange("body_html", value)
                  }
                  required={true}
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Campaign</label>
                  <input
                    type="text"
                    className="form-control"
                    value={emailFormData.metadata.campaign}
                    onChange={(e) =>
                      handleEmailFormChange(
                        "metadata.campaign",
                        e.target.value,
                      )
                    }
                    placeholder="Campaign name"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Priority</label>
                  <select
                    className="form-select"
                    value={emailFormData.metadata.priority}
                    onChange={(e) =>
                      handleEmailFormChange(
                        "metadata.priority",
                        e.target.value,
                      )
                    }
                  >
                    <option value="normal">Normal</option>
                    <option value="high">High</option>
                    <option value="low">Low</option>
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Attachments</label>
                <input
                  type="file"
                  className="form-control"
                  multiple
                  onChange={handleFileChange}
                />
                {selectedFiles.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">Selected files:</small>
                    {selectedFiles.map((file, index) => (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center mt-1"
                      >
                        <small className="text-primary">
                          {file.name} ({(file.size / 1024).toFixed(2)} KB)
                        </small>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeFile(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleEmailCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleEmailSubmit}
                disabled={!emailFormData.subject || !emailFormData.body_html}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
